export enum Keys {
  Backspace = 'Backspace',
  Tab = 'Tab',
  Enter = 'Enter',
  Space = ' ',
  Shift = 'Shift',
  Control = 'Control',
  Alt = 'Alt',
  Command = 'Meta',
  Escape = 'Escape',
  PageUp = 'PageUp',
  PageDown = 'PageDown',
  ArrowLeft = 'ArrowLeft',
  ArrowUp = 'ArrowUp',
  ArrowRight = 'ArrowRight',
  ArrowDown = 'ArrowDown',
  Delete = 'Delete',
  Fn = 'Fn',
  End = 'End',
  Home = 'Home',
  Clear = 'Clear',
  Insert = 'Insert',
  // If holding shift, these are capitalized. If case doesn't matter, compare with `e.key.toLowerCase()`
  A = 'a',
  B = 'b',
  C = 'c',
  D = 'd',
  E = 'e',
  F = 'f',
  G = 'g',
  H = 'h',
  I = 'i',
  J = 'j',
  K = 'k',
  L = 'l',
  M = 'm',
  N = 'n',
  O = 'o',
  P = 'p',
  Q = 'q',
  R = 'r',
  S = 's',
  T = 't',
  U = 'u',
  V = 'v',
  W = 'w',
  X = 'x',
  Y = 'y',
  Z = 'z',
  Zero = '0',
  One = '1',
  Two = '2',
  Three = '3',
  Four = '4',
  Five = '5',
  Six = '6',
  Seven = '7',
  Eight = '8',
  Nine = '9',
  F1 = 'F1',
  F2 = 'F2',
  F3 = 'F3',
  F4 = 'F4',
  F5 = 'F5',
  F6 = 'F6',
  F7 = 'F7',
  F8 = 'F8',
  F9 = 'F9',
  F10 = 'F10',
  F11 = 'F11',
  F12 = 'F12',
  Hyphen = '-',
  ForwardSlash = '/',
  BackSlash = '\\',
}
